import { FILTER_OPERATORS } from "../../../constants/reportBuilder.js";
import { rbInputStyle, rbSelectStyle } from "../reportBuilderTheme.js";
import { Ico } from "../../../components/icons/icons.jsx";

const VALUE_HINTS = {
  between: "min, max",
  in: "val1, val2, val3",
  contains: "search text",
};

export function FilterRow({ filter, fields, index, logic, onChange, onRemove, c, A }) {
  const valueHint = VALUE_HINTS[filter.op] ?? "Value";
  const connector = index === 0 ? "WHERE" : logic.toUpperCase();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "52px 1fr 100px 1fr 32px",
        gap: 8,
        alignItems: "end",
        padding: 12,
        background: c.card,
        borderRadius: 10,
        border: `1px solid ${c.divider}`,
      }}
    >
      <span
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.06em",
          color: index === 0 ? A : c.sub,
          paddingBottom: 10,
          textAlign: "center",
        }}
      >
        {connector}
      </span>
      <label style={{ minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: c.sub, marginBottom: 5 }}>
          Field
        </span>
        <select
          value={filter.field}
          onChange={(e) => onChange({ field: e.target.value })}
          style={rbSelectStyle(c)}
          onFocus={(e) => (e.currentTarget.style.borderColor = `${A}66`)}
          onBlur={(e) => (e.currentTarget.style.borderColor = c.cardBdr)}
        >
          <option value="">Select field</option>
          {fields.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: c.sub, marginBottom: 5 }}>
          Operator
        </span>
        <select
          value={filter.op}
          onChange={(e) => onChange({ op: e.target.value })}
          style={rbSelectStyle(c)}
          onFocus={(e) => (e.currentTarget.style.borderColor = `${A}66`)}
          onBlur={(e) => (e.currentTarget.style.borderColor = c.cardBdr)}
        >
          {FILTER_OPERATORS.map((op) => (
            <option key={op.value} value={op.value}>
              {op.label}
            </option>
          ))}
        </select>
      </label>
      <label style={{ minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: c.sub, marginBottom: 5 }}>
          Value
        </span>
        <input
          value={filter.value}
          onChange={(e) => onChange({ value: e.target.value })}
          placeholder={valueHint}
          style={rbInputStyle(c)}
          onFocus={(e) => (e.currentTarget.style.borderColor = `${A}66`)}
          onBlur={(e) => (e.currentTarget.style.borderColor = c.cardBdr)}
        />
      </label>
      <button
        type="button"
        onClick={onRemove}
        aria-label="Remove filter"
        style={{
          width: 32,
          height: 32,
          marginBottom: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 7,
          background: c.hover,
          color: "#EF4444",
          cursor: "pointer",
        }}
      >
        {Ico.x}
      </button>
    </div>
  );
}
